import _ from 'lodash'

import getLeafNodes from '/utils/get-leaf-nodes'

const sampleDataToCsv = data => {

  const leafNodes = getLeafNodes(data[0])
  let emptyItem = {}
  leafNodes.map(n => emptyItem[n] = null)

  let jsonData = []

  data.map(d => {
    let item = _.clone(emptyItem)
    
    for (let key in item) {
      _.set(item,key,_.get(d,key))
    }

    jsonData.push(item)
  })

  return jsonData
}

export default sampleDataToCsv